import script from "./MultipleAttachmentPreview.vue?vue&type=script&setup=true&lang=js"
export * from "./MultipleAttachmentPreview.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__